import React from 'react';
import PropTypes from 'prop-types';
import SponsoredProductsDescription from './SponsoredProductsDescription/SponsoredProductsDescription';
import styles from './SponsoredProducts.module.css';

const SponsoredProducts = (props) => {
  return (
    <div className={styles.sponsoredZone}>
      <div className={styles.sponsoredContent}>
        <SponsoredProductsDescription />
        {props.children}
      </div>
    </div>
  );
};

SponsoredProducts.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SponsoredProducts;
